import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import * as introJs from 'intro.js/intro.js';

@Component({
  selector: 'app-manageadminusers',
  templateUrl: './manageadminusers.component.html',
  styleUrls: ['./manageadminusers.component.css']
})
export class ManageadminusersComponent implements OnInit {
  moduleid: number;
  schoolid: number;
  tutorList: any;
  currentUserIsAdmin: boolean;
  moduleinfo: any;
  //schooldetails: any;
  introJS=new introJs();
  toursteps:any[]=[];
  @ViewChild('email') email: ElementRef;

  constructor(public modulemanager: ModulemanagementService, private route: ActivatedRoute, private toastr: ToastrService, private headerinfo: ComponentheaderService, private schoolmanager: SchoolmanagementService) {
this.toursteps= [
     
  {
    element: '#addadmin',        
     intro: ' Type in the <b>EMAIL</b> of the user to be added as '+(this.moduleid?'Tutor.':'School Admin.'),
     position: 'bottom'
  },
 {
  element: '#admintutors',
   intro: (this.moduleid?'Tutors':'School Admins.')+' that have been added are displayed here',
   position: 'top'
}
 
 
];
    this.introJS.setOptions({
      steps:this.toursteps,
   showProgress: false,
   exitOnOverlayClick: true,
   exitOnEsc:true,
   skipLabel: 'Exit',
  });

   }

  async ngOnInit() {
    this.moduleid = this.route.snapshot.queryParams.moduleid;
    this.schoolid = await this.schoolmanager.getSchoolIdFromSubdomain().toPromise();// this.route.snapshot.queryParams.schoolid;
    this.settutorList(this.moduleid, this.schoolid);
  }
  async settutorList(moduleid: any, schoolid: any) {
    let school: boolean = false;
    if (moduleid > 0) {
      let data = await this.modulemanager.getModuleUsers(this.moduleid).toPromise();
      this.tutorList = data.moduleUsers;
      this.currentUserIsAdmin = data.isAdmin;
    }
    else {
      let data: any = await this.schoolmanager.getSchoolUsers(this.schoolid).toPromise();
      this.tutorList = data.schoolUsers;
      this.currentUserIsAdmin = data.isAdmin;
      school = true;
    }
    await this.getBreadcurmbDetails(school);
  }

  async getBreadcurmbDetails(school: boolean) {
    if (!school) {
      this.moduleinfo = await this.modulemanager.getModuleInfo(this.moduleid).toPromise();
      //this.schooldetails = await this.schoolmanager.getSchoolInfo(this.moduleinfo.schoolID).toPromise();
      this.headerinfo.setHeaderDisplay("Manage Course Administrators",        
        [{ displaytext: "School", route: `/user/schoolhome` },
        { displaytext: "Course", route: `/user/moduledetails`, params: { moduleID: this.moduleid } },
        { displaytext: "Manage Admins", route: `/user/manageadminusers`, params: this.route.snapshot.queryParams }], [],this.toursteps);
    }
    else {
      //this.schooldetails = await this.schoolmanager.getSchoolInfo(this.schoolid).toPromise();
      this.headerinfo.setHeaderDisplay("Manage School Administrators",
        [
          // { displaytext: 'Home', route: '/user' },
        { displaytext: 'School', route: `/user/schoolhome` },
        { displaytext: "Manage Admins", route: `/user/manageadminusers`, params: this.route.snapshot.queryParams }], [],this.toursteps);
    }
  }

  async manageUser(moduleid: number, schoolid: number, emailToManage: string, action: string) {
    //debugger;
    if(!emailToManage){
      this.toastr.error("Enter User Email");
      throw new Error("Enter User Email");
    }
    else{
      if (moduleid > 0) {
        this.tutorList = await this.modulemanager.manageUser(moduleid, emailToManage, action).toPromise();
      }
      else {
        this.tutorList = await this.schoolmanager.manageUser(schoolid, emailToManage, action).toPromise();
      }
      //this.toastr.success(`${emailToManage} Successfully Added`);
      this.email.nativeElement.value = '';
    }
  }
  async manageuser(data: any) {
    //debugger;
    console.log(`data is ${data.email}`);
    await this.manageUser(this.moduleid, this.schoolid, data.email, data.manageaction);

    //this.toastr.success(`${data.manageaction} User Successful`);
  }

  taketour()
  {
   // this.introJS.start();
  }
}
